(function (angular) {
  "use strict";

  angular
    .module("app")
    .controller("adminStatsController", adminStatsController);

  adminStatsController.$inject = ["StatsApi"];

  function adminStatsController(StatsApi) {
    var vm = this;

    // properties
    vm.isLoading = false;
    vm.filters = {
      dateFrom: null,
      dateTo: null,
    };
    vm.stats = {};
    vm.charts = {};

    // methods
    vm.getStats = getStats;

    /**
     * Retrieves statistics from the API
     * @return {void}
     */
    function getStats() {
      vm.isLoading = true;

      // make a copy of filters and format iso dates
      var filters = angular.copy(vm.filters);
      filters.date_from = vm.filters.dateFrom
        ? window.moment(vm.filters.dateFrom).format("Y-MM-DD")
        : null;
      filters.date_to = vm.filters.dateTo
        ? window.moment(vm.filters.dateTo).format("Y-MM-DD")
        : null;

      StatsApi.get(
        filters,
        function handleGetStatsResponse(response) {
          vm.stats = response;
          buildCharts([
            "users_by_month",
            "events_by_month",
            "polls_by_month",
            "adverts_by_month",
            "advert_clicks_by_month",
          ]);
          vm.isLoading = false;
        },
        function handleGetStatsError() {
          vm.isLoading = false;
        },
      );
    }

    /**
     * Creates chart data to be consumed by the angular-charts.js directive/library
     * @param {Array} responseKeys - Array of keys in vm.stats to build charts from
     * @return {void}
     */
    function buildCharts(responseKeys) {
      angular.forEach(responseKeys, function (key) {
        var chart = {
          labels: [],
          data: [[]],
          options: {
            scales: {
              yAxes: [
                {
                  id: "y-axis-1",
                  display: true,
                  type: "linear",
                  position: "left",
                },
              ],
            },
          },
          datasetSettings: [
            {
              lineTension: 0,
            },
          ],
        };

        angular.forEach(vm.stats[key], function (pointValue, pointName) {
          chart.labels.push(pointName);
          chart.data[0].push(pointValue);
        });

        vm.charts[key] = chart;
      });
    }

    // init
    getStats();
    buildCharts([
      "users_by_month",
      "events_by_month",
      "polls_by_month",
      "adverts_by_month",
      "advert_clicks_by_month",
    ]);
  }
})(angular);
